import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import { Component, HTMLAttributes } from 'react'

import { ScrollToTop } from './ScrollToTop'

type TScrollLayoutProps = HTMLAttributes<HTMLDivElement>

@observer
export class ScrollLayout extends Component<TScrollLayoutProps> {
  scrollLayout: HTMLDivElement | null = null

  @observable
  isScrolled: boolean = false
  @observable
  isLongScroll: boolean = false

  @action
  setIsScrolled = (scrollHeight: number, clientHeight: number) => {
    this.isScrolled = true
    this.isLongScroll = scrollHeight > 4 * clientHeight
  }

  @action
  resetIsScrolled = () => {
    this.isScrolled = false
    this.isLongScroll = false
  }

  onScroll = () => {
    if (!this.scrollLayout) {
      return
    }

    if (!this.isScrolled && this.scrollLayout.scrollTop > 0) {
      const { scrollHeight, clientHeight } = this.scrollLayout
      this.setIsScrolled(scrollHeight, clientHeight)
    } else if (this.scrollLayout.scrollTop === 0) {
      this.resetIsScrolled()
    }
  }

  scrollToTop = () => {
    if (!this.scrollLayout) {
      return
    }

    this.scrollLayout.scrollTop = 0
  }

  render() {
    const { children, ...other } = this.props
    return (
      <div
        {...other}
        ref={(el) => {
          this.scrollLayout = el
        }}
        onScroll={this.onScroll}
      >
        {children}
        {this.isLongScroll && this.isScrolled && <ScrollToTop onClick={this.scrollToTop} />}
      </div>
    )
  }
}
